import {useEffect, useState} from 'react'
import {Dialog, Popover} from '@headlessui/react'
import {Bars3Icon, XMarkIcon, DocumentTextIcon} from '@heroicons/react/24/outline'
import {NavLink} from 'react-router-dom'
import {Analytics, Login, Person, TextSnippet} from "@mui/icons-material";

// const products = [
//   { name: 'Analytics', description: 'Get a better understanding of your traffic', href: '#', icon: ChartPieIcon },
//   { name: 'Engagement', description: 'Speak directly to your customers', href: '#', icon: CursorArrowRaysIcon },
//   { name: 'Security', description: 'Your customers’ data will be safe and secure', href: '#', icon: FingerPrintIcon },
//   { name: 'Integrations', description: 'Connect with third-party tools', href: '#', icon: SquaresPlusIcon },
//   { name: 'Automations', description: 'Build strategic funnels that will convert', href: '#', icon: ArrowPathIcon },
// ]
//
// const callsToAction = [
//   { name: 'Watch demo', href: '#', icon: PlayCircleIcon },
//   { name: 'Contact sales', href: '#', icon: PhoneIcon },
// ]

type NavMenuItems = {
  name: string;
  description: string;
  href: string,
  icon: any;
  isAuth: boolean;
  target: string;
}

const NavMenuItems : NavMenuItems[] = [
  { name: 'Правила', description: 'Пользовательское соглашение', href: '/rules', target: "_blank", icon: null, isAuth: true },
  { name: 'Правила', description: 'Пользовательское соглашение', href: '/rules', target: "_blank", icon: null, isAuth: false },
  { name: 'Заблокированные домены', description: 'blacklist', href: '/blacklist', target: "_blank", icon: null, isAuth: false },
  { name: 'Заблокированные домены', description: 'blacklist', href: '/blacklist', target: "_blank", icon: null, isAuth: true },
  // { name: 'Аналитика', description: 'Ваша аналитика в одному месте', href: '#analytics', target: "_self", icon: null, isAuth: false },
  // { name: 'Аналитика', description: 'Панель данных ваших ссылок', href: '/analytics', target: "_self", icon: null, isAuth: true },
  // { name: 'Авторизация', description: 'Авторизуйтесь чтобы получить доступ ко всем возможностям', href: 'https://id.rell.ru', icon: <Login/>, isAuth: false },
  // { name: '', description: 'Авторизуйтесь чтобы получить доступ ко всем возможностям', target: "_self", href: 'https://id.rell.ru', icon: <Login/>, isAuth: false },
  // { name: '#USER', description: 'Авторизуйтесь чтобы получить доступ ко всем возможностям', target: "_self", href: 'https://id.rell.ru', icon: <Person/>, isAuth: true },
]

export default function Example() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [userInfo, setUserInfo] = useState()
  const [isAuth, setIsAuth]  = useState<boolean>(false)
  const [menuItems, setMenuItems]  = useState<NavMenuItems[]>([])

  useEffect( () => {
    setMenuItems(NavMenuItems.filter(item =>  item.isAuth == isAuth))
  },[isAuth])

  return (
    <header className="bg-white">
      <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
        <div className="flex lg:flex-1">
          <NavLink to="https://rell.ru" className="-m-1.5 p-1.5">
            <span className="sr-only">Rell Tech</span>
            <img className="h-8" src="../favicon.ico" alt="logo" width={50} />
          </NavLink>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <Popover.Group className="hidden lg:flex lg:gap-x-12">
          {
            menuItems.map((item) => (
                  <NavLink to={item.href} className="text-sm font-semibold leading-6 text-gray-900" style={{display: 'inline-flex'}}>
                    {item.name}
                    {item.icon}
                  </NavLink>
                )
            )
          }
        </Popover.Group>
      </nav>
      <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <NavLink to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Rell Tech</span>
              <img
                className="h-8"
                src="../favicon.ico"
                alt="logo"
                width={50}
              />
            </NavLink>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                {
                  menuItems.map((item) => (
                      <NavLink
                          to={item.href}
                          className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                      >
                        {item.name}
                      </NavLink>
                  ))
                }
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  )
}